var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{on:{"loadingStart":_vm.onLoadingStart,"loadingStop":_vm.onLoadingStop}}),_vm._v(" "),(_vm.isLoading)?_c('ajax-spinner',{attrs:{"overlay":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }